import { Stack, Typography } from '@mui/material';
import { MotionViewport } from 'src/components/animate';
import Iconify from 'src/components/iconify';
import { Props } from 'src/features/@types/resolution';
import { Container } from 'src/features/global';
import { CustomInfo, CustomMain } from './styles';

// ---------------------------------------------------------------------------

export default function ContactUs({ resolution }: Props) {
  return (
    <Stack component={MotionViewport}>
      <Stack
        style={{
          height: '100%',
          backgroundImage: 'url(images/capa/capa4.webp)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
        }}
      >
        <Container>
          <Typography variant="h4" align="center" mb={6} mt={3}>
            Faça-nos uma visita ou entre em contato!
          </Typography>

          <CustomMain>
            <Stack width={resolution === 'mobile' ? '100%' : '50%'}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3891.757400415881!2d-60.137710924927546!3d-12.72924328756432!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x93b96bd6bea9e479%3A0xa05a0af8aaeac695!2sPafesan%20Toldos%20e%20Fachadas!5e0!3m2!1spt-BR!2sus!4v1715493575362!5m2!1spt-BR!2sus"
                width="100%"
                height="450"
                title="Mapa da localização da Empresa Física"
                loading="lazy"
              />
            </Stack>

            <Stack gap={2}>
              <CustomInfo id="Endereço">
                <Iconify icon="logos:google-maps" width={40} />
                <Typography variant="subtitle1">
                  Av. Curitiba, N° 3993, Bairro: Jardim das Oliveiras, <br />
                  CEP: 76980-670, Vilhena- RO, Brasil
                </Typography>
              </CustomInfo>

              <CustomInfo id="Telefone">
                <Iconify icon="logos:whatsapp-icon" width={40} />
                <Typography variant="subtitle1">(69) 99606-7424</Typography>
              </CustomInfo>

              <CustomInfo id="Email">
                <Iconify icon="logos:google-gmail" width={40} />
                <Typography variant="subtitle1">pafesantoldos@gmail.com</Typography>
              </CustomInfo>
            </Stack>
          </CustomMain>
        </Container>
      </Stack>
    </Stack>
  );
}
